import Vue from 'vue';
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue';
import {
  BAvatar,
  BBadge,
  BButton,
  BButtonGroup,
  BButtonClose,
  BCard,
  BCardBody,
  BCardText,
  BCardTitle,
  BCol,
  BCollapse,
  BContainer,
  BDropdown,
  BDropdownDivider,
  BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormRadioGroup,
  BFormSelect,
  BFormSelectOption,
  BFormTags,
  BFormTextarea,
  BIcon,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BLink,
  BListGroup,
  BListGroupItem,
  BImg,
  BModal,
  BNav,
  BNavItemDropdown,
  BNavbarNav,
  BOverlay,
  BPagination,
  BPopover,
  BProgress,
  BRow,
  BSpinner,
  BTab,
  BTable,
  BTabs,
  BTooltip,
  VBTooltip,
  VBToggle,
} from 'bootstrap-vue';

Vue.component(FeatherIcon.name, FeatherIcon);
Vue.component('b-avatar', BAvatar);
Vue.component('b-badge', BBadge);
Vue.component('b-button', BButton);
Vue.component('b-button-group', BButtonGroup);
Vue.component('b-button-close', BButtonClose);
Vue.component('b-card', BCard);
Vue.component('b-card-body', BCardBody);
Vue.component('b-card-text', BCardText);
Vue.component('b-card-title', BCardTitle);
Vue.component('b-col', BCol);
Vue.component('b-collapse', BCollapse);
Vue.component('b-container', BContainer);
Vue.component('b-dropdown', BDropdown);
Vue.component('b-dropdown-divider', BDropdownDivider);
Vue.component('b-dropdown-item', BDropdownItem);
Vue.component('b-form', BForm);
Vue.component('b-form-checkbox', BFormCheckbox);
Vue.component('b-form-group', BFormGroup);
Vue.component('b-form-input', BFormInput);
Vue.component('b-form-invalid-feedback', BFormInvalidFeedback);
Vue.component('b-form-radio-group', BFormRadioGroup);
Vue.component('b-form-select', BFormSelect);
Vue.component('b-form-select-option', BFormSelectOption);
Vue.component('b-form-tags', BFormTags);
Vue.component('b-form-textarea', BFormTextarea);
Vue.component('b-icon', BIcon);
Vue.component('b-input-group', BInputGroup);
Vue.component('b-input-group-append', BInputGroupAppend);
Vue.component('b-input-group-prepend', BInputGroupPrepend);
Vue.component('b-link', BLink);
Vue.component('b-list-group', BListGroup);
Vue.component('b-list-group-item', BListGroupItem);
Vue.component('b-img', BImg);
Vue.component('b-modal', BModal);
Vue.component('b-nav', BNav);
Vue.component('b-nav-item-dropdown', BNavItemDropdown);
Vue.component('b-navbar-nav', BNavbarNav);
Vue.component('b-overlay', BOverlay);
Vue.component('b-pagination', BPagination);
Vue.component('b-popover', BPopover);
Vue.component('b-progress', BProgress);
Vue.component('b-row', BRow);
Vue.component('b-spinner', BSpinner);
Vue.component('b-tab', BTab);
Vue.component('b-table', BTable);
Vue.component('b-tabs', BTabs);
Vue.component('b-tooltip', BTooltip);
Vue.directive('b-tooltip', VBTooltip);
Vue.directive('b-toggle', VBToggle);
